export enum COLORS {
  DARK_BLUE = `#004C97`,
  LIGHT_BLUE = `#00B5EF`
}
